import { formatPhoneNumber } from '@gusto/workbench';
import type { CompanyLead } from 'packages/signup/components/signupForm/types';

export const INDUSTRY_SETTING_OPTIONS = [
  { label: 'Please select...', value: '' },
  { label: 'Healthcare, wellness, and fitness', value: 'Healthcare, wellness, and fitness' },
  { label: 'Professional services', value: 'Professional services' },
  { label: 'Technology', value: 'Technology' },
  { label: 'Financial services', value: 'Financial services' },
  { label: 'Non-profit', value: 'Non-profit' },
  { label: 'Other', value: 'Other' },
];

export const PREV_PAYROLL_PROVIDER = [
  { label: 'How do you currently run payroll?', value: '' },
  { label: "We're new to running payroll", value: 'New' },
  { label: 'We use another online payroll software', value: 'Other' },
  { label: 'We do it ourselves manually', value: 'We do it ourselves manually' },
];

export const leadFormInitialValues = (companyLead?: CompanyLead) => ({
  companyName: companyLead?.company_name || '',
  email: companyLead?.email || '',
  firstName: companyLead?.first_name || '',
  lastName: companyLead?.last_name || '',
  numberEmployees: companyLead?.number_employees || '',
  industry: companyLead?.industry || '',
  phone: companyLead?.phone ? formatPhoneNumber(companyLead.phone) : '',
});
